import { S3_BASE } from '../../../constants';
function newAlbumPage(urlPath, title, images) {
  return { urlPath, title, images };
}

export default function getAlbumPages() {
  return [
    newAlbumPage('2026-le-cong-bo-chung-nhan-sinh-hoat-ton-giao-tap-trung-dao-trang-nhat-ton-nhu-lai-tang-ngay-20-thang-1-nam-binh-ngo', '2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)', [
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_BC10797.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_BC10830.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_BC10895.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_BC10902.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_BC10908.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_BC10911.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_BC10929.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_BC10948.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_BC10954.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_BC10963.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_BC10971.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_BC10974.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_BC10983.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_BC10994.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_BC11001.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_BC11033.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_BC11064.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_GT17252.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_GT17308.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_GT17309.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_GT17339.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_GT17464.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_GT17475.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_GT17491.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_GT17497.jpg`,
      `${S3_BASE}/2026 Lễ công bố chứng nhận sinh hoạt tôn giáo tập trung Đạo Tràng Nhất Tôn Như Lai Tạng ( Ngày 20 tháng 1 năm Bính Ngọ)/_GT17513.jpg`,
    ]),
    newAlbumPage('2026-dai-le-khai-nguyen-ngay-12-thang-1-nam-binh-ngo', '2026 Đại lễ Khai Nguyên (Ngày 12 tháng 1 năm Bính Ngọ)', [
      `${S3_BASE}/2026 Đại lễ Khai Nguyên (Ngày 12 tháng 1 năm Bính Ngọ)/_BC10267.jpg`,
      `${S3_BASE}/2026 Đại lễ Khai Nguyên (Ngày 12 tháng 1 năm Bính Ngọ)/_BC10541.jpg`,
      `${S3_BASE}/2026 Đại lễ Khai Nguyên (Ngày 12 tháng 1 năm Bính Ngọ)/_BC10560.jpg`,
      `${S3_BASE}/2026 Đại lễ Khai Nguyên (Ngày 12 tháng 1 năm Bính Ngọ)/_BC10564.jpg`,
      `${S3_BASE}/2026 Đại lễ Khai Nguyên (Ngày 12 tháng 1 năm Bính Ngọ)/_BC10574.jpg`,
    ]),
    newAlbumPage('2026-dai-le-dan-sanh-ngay-24-thang-12-nam-at-ty', '2026 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Ất Tỵ)', [
      `${S3_BASE}/2026 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Ất Tỵ)/_BC10010.jpg`,
      `${S3_BASE}/2026 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Ất Tỵ)/_BC10011.jpg`,
      `${S3_BASE}/2026 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Ất Tỵ)/_BC10012.jpg`,
      `${S3_BASE}/2026 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Ất Tỵ)/_BC10013.jpg`,
      `${S3_BASE}/2026 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Ất Tỵ)/_BC10029.jpg`,
      `${S3_BASE}/2026 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Ất Tỵ)/_BC10030.jpg`,
      `${S3_BASE}/2026 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Ất Tỵ)/_BC10067.jpg`,
      `${S3_BASE}/2026 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Ất Tỵ)/_BC10091.jpg`,
      `${S3_BASE}/2026 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Ất Tỵ)/_BC10093.jpg`,
      `${S3_BASE}/2026 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Ất Tỵ)/_BC10113.jpg`,
      `${S3_BASE}/2026 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Ất Tỵ)/_BC10121.jpg`,
      `${S3_BASE}/2026 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Ất Tỵ)/_BC10126.jpg`,
      `${S3_BASE}/2026 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Ất Tỵ)/_BC10139.jpg`,
      `${S3_BASE}/2026 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Ất Tỵ)/_BC10174.jpg`,
      `${S3_BASE}/2026 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Ất Tỵ)/_BC10197.jpg`,
      `${S3_BASE}/2026 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Ất Tỵ)/_BC10207.jpg`,
    ]),
    newAlbumPage('2025-dai-le-via-duc-dong-do-duoc-su-luu-ly-quang-nhu-lai-ngay-30-thang-9-nam-at-ty', '2025 Đại lễ Vía Đức Đông Độ Dược Sư Lưu Ly Quang Như Lai (ngày 30 tháng 9 năm Ất Tỵ)', [
      `${S3_BASE}/2025 Đại lễ Vía Đức Đông Độ Dược Sư Lưu Ly Quang Như Lai (ngày 30 tháng 9 năm Ất Tỵ)/Sinhnhatdaotrang.JPG`,
      `${S3_BASE}/2025 Đại lễ Vía Đức Đông Độ Dược Sư Lưu Ly Quang Như Lai (ngày 30 tháng 9 năm Ất Tỵ)/Sinhnhatdaotrang1.JPG`,
      `${S3_BASE}/2025 Đại lễ Vía Đức Đông Độ Dược Sư Lưu Ly Quang Như Lai (ngày 30 tháng 9 năm Ất Tỵ)/Sinhnhatdaotrang2.JPG`,
      `${S3_BASE}/2025 Đại lễ Vía Đức Đông Độ Dược Sư Lưu Ly Quang Như Lai (ngày 30 tháng 9 năm Ất Tỵ)/Sinhnhatdaotrang3.JPG`,
      `${S3_BASE}/2025 Đại lễ Vía Đức Đông Độ Dược Sư Lưu Ly Quang Như Lai (ngày 30 tháng 9 năm Ất Tỵ)/Sinhnhatdaotrang4.JPG`,
      `${S3_BASE}/2025 Đại lễ Vía Đức Đông Độ Dược Sư Lưu Ly Quang Như Lai (ngày 30 tháng 9 năm Ất Tỵ)/Sinhnhatdaotrang5.JPG`,
      `${S3_BASE}/2025 Đại lễ Vía Đức Đông Độ Dược Sư Lưu Ly Quang Như Lai (ngày 30 tháng 9 năm Ất Tỵ)/Sinhnhatdaotrang6.JPG`,
    ]),
    newAlbumPage('2025-le-vu-lan-ngay-15-thang-7-nam-at-ty', '2025 Lễ Vu Lan (ngày 15 tháng 7 năm Ất Tỵ)', [
      `${S3_BASE}/2025 Lễ Vu Lan (ngày 15 tháng 7 năm Ất Tỵ)/IMG_5862.JPG`,
      `${S3_BASE}/2025 Lễ Vu Lan (ngày 15 tháng 7 năm Ất Tỵ)/IMG_5869.JPG`,
      `${S3_BASE}/2025 Lễ Vu Lan (ngày 15 tháng 7 năm Ất Tỵ)/IMG_5881.JPG`,
      `${S3_BASE}/2025 Lễ Vu Lan (ngày 15 tháng 7 năm Ất Tỵ)/IMG_5889.JPG`,
      `${S3_BASE}/2025 Lễ Vu Lan (ngày 15 tháng 7 năm Ất Tỵ)/IMG_5892.JPG`,
    ]),
    newAlbumPage('2025-chinh-trang-chanh-dien-dai-le-ton-chinh-tuong-phap-quoc-do-ngay-5-thang-4-nam-at-ty', '2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)', [
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5268.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5269.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5285.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5297.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5308.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5329.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5347.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5382.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5393.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5458.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5465.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5469.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5480.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5503.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5521.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5533.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5617.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5754.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5759.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5764.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5770.jpg`,
      `${S3_BASE}/2025 Chỉnh Trang Chánh Điện, Đại Lễ Tôn Chỉnh Tướng Pháp Quốc Độ (Ngày 5 tháng 4 năm Ất Tỵ)/IMG_5773.jpg`,
    ]),
    newAlbumPage('2025-dai-le-phat-dan', '2025 Đại Lễ Phật Đản (ngày 8 tháng 4, năm Ất Tỵ)', [
      `${S3_BASE}/2025-dai-le-phat-dan/20250505_081346.jpg`,
      `${S3_BASE}/2025-dai-le-phat-dan/20250505_085833.jpg`,
      `${S3_BASE}/2025-dai-le-phat-dan/20250505_082705.jpg`,
      `${S3_BASE}/2025-dai-le-phat-dan/retouch_2025050516172462.jpg`,
      `${S3_BASE}/2025-dai-le-phat-dan/retouch_2025050516172271.jpg`,
      `${S3_BASE}/2025-dai-le-phat-dan/20250505_073759.jpg`,
      `${S3_BASE}/2025-dai-le-phat-dan/20250505_073819.jpg`,
      `${S3_BASE}/2025-dai-le-phat-dan/20250505_073832.jpg`,
      `${S3_BASE}/2025-dai-le-phat-dan/retouch_2025050723262309.jpg`,
      `${S3_BASE}/2025-dai-le-phat-dan/retouch_2025050516172074.jpg`,
      `${S3_BASE}/2025-dai-le-phat-dan/20250505_041947.jpg`,
    ]),
    newAlbumPage('2025-dai-le-tinh-vuong-ty-lo-gia-na', '2025 Đại Lễ Tịnh Vương Tỳ Lô Giá Na (ngày 10 tháng 3, năm Ất Tỵ)', [
      `${S3_BASE}/2025-dai-le-tinh-vuong-ty-lo-gia-na/1.jpg`,
      `${S3_BASE}/2025-dai-le-tinh-vuong-ty-lo-gia-na/2.jpg`,
      `${S3_BASE}/2025-dai-le-tinh-vuong-ty-lo-gia-na/3.jpg`,
      `${S3_BASE}/2025-dai-le-tinh-vuong-ty-lo-gia-na/4.jpg`,
      `${S3_BASE}/2025-dai-le-tinh-vuong-ty-lo-gia-na/5.jpg`,
      `${S3_BASE}/2025-dai-le-tinh-vuong-ty-lo-gia-na/6.jpg`,
      `${S3_BASE}/2025-dai-le-tinh-vuong-ty-lo-gia-na/7(1).jpg`,
      `${S3_BASE}/2025-dai-le-tinh-vuong-ty-lo-gia-na/7.jpg`,
      `${S3_BASE}/2025-dai-le-tinh-vuong-ty-lo-gia-na/8.jpg`,
      `${S3_BASE}/2025-dai-le-tinh-vuong-ty-lo-gia-na/9(1).jpg`,
      `${S3_BASE}/2025-dai-le-tinh-vuong-ty-lo-gia-na/9.jpg`,
      `${S3_BASE}/2025-dai-le-tinh-vuong-ty-lo-gia-na/10.jpg`,
    ]),
    newAlbumPage('2025-dai-le-khai-nguyen', '2025 Đại lễ Khai Nguyên (ngày 12 tháng 1, năm Ất Tỵ)', [
      `${S3_BASE}/2025-dai-le-khai-nguyen/20250209_095622.jpg`,
      `${S3_BASE}/2025-dai-le-khai-nguyen/_GT16480-1.jpg`,
      `${S3_BASE}/2025-dai-le-khai-nguyen/_GT16481.jpg`,
      `${S3_BASE}/2025-dai-le-khai-nguyen/_GT16483.jpg`,
      `${S3_BASE}/2025-dai-le-khai-nguyen/_GT16484.jpg`,
      `${S3_BASE}/2025-dai-le-khai-nguyen/_GT16493.jpg`,
      `${S3_BASE}/2025-dai-le-khai-nguyen/_GT16496.jpg`,
      `${S3_BASE}/2025-dai-le-khai-nguyen/_GT16498.jpg`,
      `${S3_BASE}/2025-dai-le-khai-nguyen/_GT16500-1.jpg`,
    ]),
    newAlbumPage('2025-dai-le-dan-sanh', '2025 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Giáp Thìn)', [
      `${S3_BASE}/2025-dai-le-dan-sanh/_GT16261.jpg`,
      `${S3_BASE}/2025-dai-le-dan-sanh/_GT16267.jpg`,
      `${S3_BASE}/2025-dai-le-dan-sanh/_GT16269.jpg`,
      `${S3_BASE}/2025-dai-le-dan-sanh/_GT16279.jpg`,
      `${S3_BASE}/2025-dai-le-dan-sanh/_GT16403.jpg`,
      `${S3_BASE}/2025-dai-le-dan-sanh/_GT16406.jpg`,
      `${S3_BASE}/2025-dai-le-dan-sanh/_GT16415.jpg`,
      `${S3_BASE}/2025-dai-le-dan-sanh/_GT16428.jpg`,
      `${S3_BASE}/2025-dai-le-dan-sanh/_GT16456.jpg`,
      `${S3_BASE}/2025-dai-le-dan-sanh/_GT16457.jpg`,
      `${S3_BASE}/2025-dai-le-dan-sanh/_GT16463.jpg`,
    ]),
    newAlbumPage('2024-le-an-vi-tuong', '2024 Lễ An Vị Tượng Quan Âm Và Tượng Phổ Hiền (ngày 26 tháng 9, năm Giáp Thìn)', [
      `${S3_BASE}/2024-le-an-vi-tuong/ntnlt02.JPG`,
      `${S3_BASE}/2024-le-an-vi-tuong/ntnlt15.JPG`,
      `${S3_BASE}/2024-le-an-vi-tuong/ntnlt16.JPG`,
      `${S3_BASE}/2024-le-an-vi-tuong/ntnlt09.JPG`,
      `${S3_BASE}/2024-le-an-vi-tuong/ntnlt14.JPG`,
      `${S3_BASE}/2024-le-an-vi-tuong/ntnlt11.JPG`,
      `${S3_BASE}/2024-le-an-vi-tuong/ntnlt10.JPG`,
      `${S3_BASE}/2024-le-an-vi-tuong/ntnlt12.JPG`,
      `${S3_BASE}/2024-le-an-vi-tuong/ntnlt13.JPG`,
      `${S3_BASE}/2024-le-an-vi-tuong/ntnlt03.JPG`,
      `${S3_BASE}/2024-le-an-vi-tuong/ntnlt04.JPG`,
      `${S3_BASE}/2024-le-an-vi-tuong/ntnlt05.JPG`,
      `${S3_BASE}/2024-le-an-vi-tuong/ntnlt06.JPG`,
    ]),
    newAlbumPage('2024-dai-le-trung-thu', '2024 Tri Ân Tam Thế Phật - Đại Lễ Trung Thu (ngày 15 tháng 8, năm Giáp Thìn)', [
      `${S3_BASE}/2024-dai-le-trung-thu/_NIK5675.JPG`,
      `${S3_BASE}/2024-dai-le-trung-thu/_NIK5677.JPG`,
      `${S3_BASE}/2024-dai-le-trung-thu/IMG_9094.JPG`,
      `${S3_BASE}/2024-dai-le-trung-thu/_NIK5687.JPG`,
      `${S3_BASE}/2024-dai-le-trung-thu/_NIK5693.JPG`,
      `${S3_BASE}/2024-dai-le-trung-thu/_NIK5694.JPG`,
      `${S3_BASE}/2024-dai-le-trung-thu/_NIK5698.JPG`,
      `${S3_BASE}/2024-dai-le-trung-thu/_NIK5702.JPG`,
      `${S3_BASE}/2024-dai-le-trung-thu/_NIK5704.JPG`,
      `${S3_BASE}/2024-dai-le-trung-thu/IMG_9105.JPG`,
    ]),
    newAlbumPage('2024-dai-le-vu-lan', '2024 Đại Lễ Vu Lan (ngày 15 tháng 7, năm Giáp Thìn)', [
      `${S3_BASE}/2024-dai-le-vu-lan/img_6.JPG`,
      `${S3_BASE}/2024-dai-le-vu-lan/img_1.JPG`,
      `${S3_BASE}/2024-dai-le-vu-lan/img_2.JPG`,
      `${S3_BASE}/2024-dai-le-vu-lan/img_3.JPG`,
      `${S3_BASE}/2024-dai-le-vu-lan/img_4.JPG`,
      `${S3_BASE}/2024-dai-le-vu-lan/img_5.JPG`,
    ]),
    newAlbumPage('2024-dai-le-tinh-vuong-ty-lo-gia-na', '2024 Đại Lễ Tịnh Vương Tỳ Lô Giá Na (ngày 10 tháng 3, năm Giáp Thìn)', [
      `${S3_BASE}/2024-dai-le-tinh-vuong-ty-lo-gia-na/_NIK5512.JPG`,
      `${S3_BASE}/2024-dai-le-tinh-vuong-ty-lo-gia-na/_NIK5483.JPG`,
      `${S3_BASE}/2024-dai-le-tinh-vuong-ty-lo-gia-na/_NIK5486.JPG`,
      `${S3_BASE}/2024-dai-le-tinh-vuong-ty-lo-gia-na/_NIK5490.JPG`,
      `${S3_BASE}/2024-dai-le-tinh-vuong-ty-lo-gia-na/_NIK5488.JPG`,
      `${S3_BASE}/2024-dai-le-tinh-vuong-ty-lo-gia-na/_NIK5495.JPG`,
      `${S3_BASE}/2024-dai-le-tinh-vuong-ty-lo-gia-na/_NIK5493.JPG`,
      `${S3_BASE}/2024-dai-le-tinh-vuong-ty-lo-gia-na/_NIK5455.JPG`,
      `${S3_BASE}/2024-dai-le-tinh-vuong-ty-lo-gia-na/_NIK5457.JPG`,
      `${S3_BASE}/2024-dai-le-tinh-vuong-ty-lo-gia-na/_NIK5447.JPG`,
      `${S3_BASE}/2024-dai-le-tinh-vuong-ty-lo-gia-na/_NIK5448.JPG`,
    ]),
    newAlbumPage('2024-dai-le-khai-nguyen', '2024 Đại Lễ Khai Nguyên (ngày 12 tháng 1, năm Giáp Thìn)', [
      `${S3_BASE}/2024-dai-le-khai-nguyen/IMG4176.JPG`,
      `${S3_BASE}/2024-dai-le-khai-nguyen/_BC17685.JPG`,
      `${S3_BASE}/2024-dai-le-khai-nguyen/_BC17692.JPG`,
      `${S3_BASE}/2024-dai-le-khai-nguyen/_BC17704.JPG`,
      `${S3_BASE}/2024-dai-le-khai-nguyen/_BC17717.JPG`,
      `${S3_BASE}/2024-dai-le-khai-nguyen/_BC17711.JPG`,
      `${S3_BASE}/2024-dai-le-khai-nguyen/_BC17724.JPG`,
      `${S3_BASE}/2024-dai-le-khai-nguyen/_BC17678.JPG`,
      `${S3_BASE}/2024-dai-le-khai-nguyen/IMG_4169.JPG`,
      `${S3_BASE}/2024-dai-le-khai-nguyen/_BC17943.JPG`,
      `${S3_BASE}/2024-dai-le-khai-nguyen/_BC17958.JPG`,
      `${S3_BASE}/2024-dai-le-khai-nguyen/_BC17942.JPG`,
      `${S3_BASE}/2024-dai-le-khai-nguyen/_BC17960.JPG`,
    ]),
    newAlbumPage('2024-vui-xuan-giap-thin', '2024 Các Hoạt Động Vui Đón Xuân Giáp Thìn', [
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3949.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3850.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3557.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3556.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3975.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3976.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3977.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3553.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3559.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3554.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3990.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3972.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3973.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3971.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3962.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3560.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3561.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3563.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3980.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3981.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3941.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3942.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3944.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3943.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3945.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3947.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3951.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3950.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3952.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3982.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3983.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3984.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3985.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3986.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3989.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3993.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3994.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3995.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_3991.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_4002.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_4008.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_4009.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_4010.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_4011.JPG`,
      `${S3_BASE}/2024-vui-xuan-giap-thin/IMG_4012.JPG`,
    ]),
    newAlbumPage('2024-ton-giao-phuong-22', '2024 Đoàn Thể Chính Trị, Tôn Giáo Phường 22, Quận Bình Thạnh Thăm Đạo Tràng Di Lạc (ngày 5 tháng 2 năm 2024)', [
      `${S3_BASE}/2024-ton-giao-phuong-22/IMG_3617.JPG`,
      `${S3_BASE}/2024-ton-giao-phuong-22/IMG_3620.JPG`,
      `${S3_BASE}/2024-ton-giao-phuong-22/IMG_3631.JPG`,
      `${S3_BASE}/2024-ton-giao-phuong-22/IMG_3632.JPG`,
      `${S3_BASE}/2024-ton-giao-phuong-22/IMG_3639.JPG`,
      `${S3_BASE}/2024-ton-giao-phuong-22/IMG_3642.JPG`,
      `${S3_BASE}/2024-ton-giao-phuong-22/IMG_3644.JPG`,
    ]),
    newAlbumPage('2024-vieng-thap-thay-tai-nha-trang', '2024 Tứ Chúng Viếng Bảo Tháp Đức Ngài Tại Nha Trang (ngày 20 tháng 1 năm 2024, nhằm ngày 10 tháng 12 năm Quý Mão)', [
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/Photo 2024-02-16 21.02.55.jpg`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/_BC17370.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/_BC17373.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/_BC17387.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/_BC17390.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/_BC17391.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/_BC17402.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/IMG_0587.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/IMG_2990.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/IMG_3010.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/IMG_3022.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/IMG_3023.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/IMG_3029.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/IMG_3032.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/IMG_3139.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/IMG_3140.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/IMG_3141.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/IMG_3142.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/IMG_3963.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/IMG_3964.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/IMG_3965.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/IMG_3966.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/IMG_3967.JPG`,
      `${S3_BASE}/2024-vieng-thap-thay-tai-nha-trang/IMG_3969.JPG`,
    ]),
    newAlbumPage('2024-dai-le-dan-sanh', '2024 Đại Lễ Đản Sanh (ngày 24 tháng 12 năm Quý Mão)', [
      `${S3_BASE}/2024-dai-le-dan-sanh/IMG_3528.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/IMG_3412.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/IMG_3413.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17446.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/IMG_3423.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17461.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17455.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/IMG_3454.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17474.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17476.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17477.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/IMG_3470.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/IMG_3472.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/IMG_3449.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17484.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/IMG_3459.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17491.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17494.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/IMG3550.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17531.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17551.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17554.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17535.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17542.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17560.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17563.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/IMG_3535.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/IMG_3540.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/IMG_3526.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17568.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/IMG_3549.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17574.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17576.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17581.JPG`,
      `${S3_BASE}/2024-dai-le-dan-sanh/_BC17588.JPG`,
    ]),
    newAlbumPage('2024-le-dan-sanh-130ntt', '2024 Đại Lễ Đản Sanh Tại Đạo Tràng Di Lạc (ngày 23 tháng 12 năm Quý Mão)', [
      `${S3_BASE}/2024-le-dan-sanh-130ntt/_BC17416.JPG`,
      `${S3_BASE}/2024-le-dan-sanh-130ntt/_BC17418.JPG`,
      `${S3_BASE}/2024-le-dan-sanh-130ntt/_BC17424.JPG`,
      `${S3_BASE}/2024-le-dan-sanh-130ntt/_BC17429.JPG`,
      `${S3_BASE}/2024-le-dan-sanh-130ntt/_BC17432.JPG`,
      `${S3_BASE}/2024-le-dan-sanh-130ntt/IMG_3394.JPG`,
      `${S3_BASE}/2024-le-dan-sanh-130ntt/IMG_3395.JPG`,
      `${S3_BASE}/2024-le-dan-sanh-130ntt/IMG_3397.JPG`,
      `${S3_BASE}/2024-le-dan-sanh-130ntt/IMG_3399.JPG`,
      `${S3_BASE}/2024-le-dan-sanh-130ntt/IMG_3401.JPG`,
      `${S3_BASE}/2024-le-dan-sanh-130ntt/IMG_3402.JPG`,
      `${S3_BASE}/2024-le-dan-sanh-130ntt/IMG_3403.JPG`,
      `${S3_BASE}/2024-le-dan-sanh-130ntt/IMG_3404.JPG`,
      `${S3_BASE}/2024-le-dan-sanh-130ntt/IMG_3407.JPG`,
    ]),
    newAlbumPage('2023-le-nhan-giay-phep-130-ntt', '2023 Lễ Nhận Giấy Phép Đạo Tràng Di Lạc (Hồ Chí Minh, ngày 1 tháng 12 năm 2023)', [
      `${S3_BASE}/2023-le-nhan-giay-phep-130-ntt/IMG_1337.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-130-ntt/IMG_1338.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-130-ntt/IMG_1363.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-130-ntt/IMG_1255.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-130-ntt/IMG_1343(1).JPG`,
    ]),
    newAlbumPage('2023-le-nhan-giay-phep-quang-ngai', '2023 Lễ Nhận Giấy Phép Tại Đạo Tràng Như Lai Thiền (Quảng Ngãi, ngày 14 tháng 6 năm 2023)', [
      `${S3_BASE}/2023-le-nhan-giay-phep-quang-ngai/0U5A4849.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-quang-ngai/0U5A4854.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-quang-ngai/0U5A4857.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-quang-ngai/0U5A4883.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-quang-ngai/0U5A4888.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-quang-ngai/0U5A4898.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-quang-ngai/UI5A1502.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-quang-ngai/UI5A1508.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-quang-ngai/UI5A1510.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-quang-ngai/UI5A1551.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-quang-ngai/UI5A1601.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-quang-ngai/UI5A1614.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-quang-ngai/UI5A1620.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-quang-ngai/UI5A1631.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-quang-ngai/UI5A1640.JPG`,
      `${S3_BASE}/2023-le-nhan-giay-phep-quang-ngai/20231227_123457.jpeg`,
      `${S3_BASE}/2023-le-nhan-giay-phep-quang-ngai/20231227_123628.jpeg`,
    ]),
    newAlbumPage('2023-le-an-vi-tai-nha-thien', '2023 Lễ An Vị Tại Nhà Thiền, (ngày 5 tháng 2 năm 2023, nhằm ngày 15 tháng 1 năm Quý Mão)', [
      `${S3_BASE}/2023-le-an-vi-tai-nha-thien/IMG_8086.jpg`,
      `${S3_BASE}/2023-le-an-vi-tai-nha-thien/IMG_8140.jpeg`,
      `${S3_BASE}/2023-le-an-vi-tai-nha-thien/IMG_8143.jpeg`,
      `${S3_BASE}/2023-le-an-vi-tai-nha-thien/IMG_4185.JPG`,
      `${S3_BASE}/2023-le-an-vi-tai-nha-thien/IMG_4193.JPG`,
      `${S3_BASE}/2023-le-an-vi-tai-nha-thien/IMG_4195.JPG`,
      `${S3_BASE}/2023-le-an-vi-tai-nha-thien/IMG_4234 - Copy.JPG`,
    ]),
    newAlbumPage('2023-dai-le-phat-dan', '2023 Đại Lễ Phật Đản (ngày 8 tháng 4, năm Quý Mão)', [
      `${S3_BASE}/2023-dai-le-phat-dan/IMG_7458.JPG`,
      `${S3_BASE}/2023-dai-le-phat-dan/IMG_7462.JPG`,
      `${S3_BASE}/2023-dai-le-phat-dan/IMG_7464.JPG`,
      `${S3_BASE}/2023-dai-le-phat-dan/IMG_7465.JPG`,
      `${S3_BASE}/2023-dai-le-phat-dan/IMG_7484.JPG`,
      `${S3_BASE}/2023-dai-le-phat-dan/IMG_7492.JPG`,
      "https://www.youtube.com/embed/DdG2u_-6GBg?si=cQJZloir8e8QUYlg",
    ]),
    newAlbumPage('2023-dai-le-khai-nguyen', '2023 Đại Lễ Khai Nguyên (ngày 12 tháng 1, năm Quý Mão)', [
      `${S3_BASE}/2023-dai-le-khai-nguyen/IMG_3887.JPG`,
      `${S3_BASE}/2023-dai-le-khai-nguyen/IMG_3893.JPG`,
      `${S3_BASE}/2023-dai-le-khai-nguyen/IMG_3906.JPG`,
      `${S3_BASE}/2023-dai-le-khai-nguyen/IMG_3909.JPG`,
      `${S3_BASE}/2023-dai-le-khai-nguyen/IMG_3921.JPG`,
    ]),
    newAlbumPage('2023-dai-le-dan-sanh', '2023 Đại Lễ Đản Sanh (ngày 24 tháng 12, năm Nhâm Dần)', [
      `${S3_BASE}/2023-dai-le-dan-sanh/_BC15032.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/_BC14970.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/_BC15073.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/_BC15101.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/_BC15111.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/IMG_3745.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/IMG_3780.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/_BC15129.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/_BC15133.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/IMG_3774.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/IMG_3653.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/_BC15146.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/IMG_3617.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/IMG_3642.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/_BC14952.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/_BC14956.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/_BC14961.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/_BC14967.JPG`,
      `${S3_BASE}/2023-dai-le-dan-sanh/_BC15087.JPG`,
    ]),
    newAlbumPage('2022-dai-le-khai-nguyen', '2022 Đại Lễ Khai Nguyên (ngày 12 tháng 1, năm Nhâm Dần)', [
      `${S3_BASE}/2022-dai-le-khai-nguyen/IMG_3000.JPG`,
      `${S3_BASE}/2022-dai-le-khai-nguyen/IMG_3006.JPG`,
      `${S3_BASE}/2022-dai-le-khai-nguyen/IMG_3007.JPG`,
      `${S3_BASE}/2022-dai-le-khai-nguyen/IMG_3011.JPG`,
      `${S3_BASE}/2022-dai-le-khai-nguyen/IMG_3016.JPG`,
      `${S3_BASE}/2022-dai-le-khai-nguyen/IMG_3022.JPG`,
      `${S3_BASE}/2022-dai-le-khai-nguyen/IMG_3023.JPG`,
      `${S3_BASE}/2022-dai-le-khai-nguyen/IMG_3036.JPG`,
      `${S3_BASE}/2022-dai-le-khai-nguyen/IMG_3043.JPG`,
    ]),
    newAlbumPage('2022-dai-le-dan-sanh', '2022 Đại Lễ Đản Sanh (ngày 24 tháng 12, năm Tân Sửu)', [
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2496.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2524.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2527.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2537.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2546.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/_BC13322.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/_BC13296.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2586.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2644.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/_BC13354.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2633.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/_BC13357.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2604.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2652.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2667.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/_BC13464.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/_BC13504.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/_BC13509.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2738.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2779.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/BC13510.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2382.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2417.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2433.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2440.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2466.JPG`,
      `${S3_BASE}/2022-dai-le-dan-sanh/IMG_2488.JPG`,
    ]),
    newAlbumPage('2020-le-29-thang-9', '2020 Đại Lễ Vía Đức Đông Độ Dược Sư Lưu Ly Quang Như Lai (ngày 29 Tháng 9, năm Canh Tý)', [
      `${S3_BASE}/2020-le-29-thang-9/IMG_1210.JPG`,
      `${S3_BASE}/2020-le-29-thang-9/IMG_1213.JPG`,
      `${S3_BASE}/2020-le-29-thang-9/IMG_1216.JPG`,
      `${S3_BASE}/2020-le-29-thang-9/IMG_1234.JPG`,
      `${S3_BASE}/2020-le-29-thang-9/IMG_1239.JPG`,
      `${S3_BASE}/2020-le-29-thang-9/IMG_1245.JPG`,
      `${S3_BASE}/2020-le-29-thang-9/IMG_1248.JPG`,
      `${S3_BASE}/2020-le-29-thang-9/IMG_1258.JPG`,
      `${S3_BASE}/2020-le-29-thang-9/IMG_1272.JPG`,
    ]),
  ]
}

